import makeRequest from '@jg/http-client';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import config from '../../config';
import { ERROR_MESSAGES } from '../../consts';
import { IAppState } from '../../types/state.d';
import { getEventId } from '../../selectors/apiSelectors';
import {
  getEventRequestMade,
  getEventRequestSuccess,
  getEventRequestError,
} from '../actionCreators/apiActions';

const fetchEventDetails = () => async (
  dispatch: ThunkDispatch<IAppState, void, Action>,
  getState: () => IAppState,
) => {
  try {
    dispatch(getEventRequestMade());
    const eventId = getEventId(getState());
    const response = await makeRequest(`${config.eventsAPI}${eventId}`, {
      credentials: 'omit',
    });

    if (response && !response.ok) {
      throw new Error(ERROR_MESSAGES.GET_EVENT_DETAILS);
    }

    const data = await response.json();
    dispatch(getEventRequestSuccess(data));
  } catch (error) {
    dispatch(getEventRequestError(error.message));
  }
};

export default fetchEventDetails;
